import { useContext } from 'react';
import { LayoutContext } from '../components/layout/LayoutContext';

export function useAppSidebarCollapsed() {
  const ctx = useContext(LayoutContext);
  if (!ctx) {
    throw new Error('useAppSidebarCollapsed must be used inside <LayoutProvider>');
  }
  return ctx;
}
